/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface AiModelName
 */
export interface AiModelName {
  /**
   *
   * @type {number}
   * @memberof AiModelName
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AiModelName
   */
  name: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof AiModelName
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {UseCaseName}
   * @memberof AiModelName
   */
  readonly useCase: UseCaseName;
}

/**
 * Check if a given object implements the AiModelName interface.
 */
export function instanceOfAiModelName(value: object): value is AiModelName {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  return true;
}

export function AiModelNameFromJSON(json: any): AiModelName {
  return AiModelNameFromJSONTyped(json, false);
}

export function AiModelNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModelName {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    useCase: UseCaseNameFromJSON(json['use_case']),
  };
}

export function AiModelNameToJSON(value?: Omit<AiModelName, 'id' | 'useCase'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
